import React from 'react'
import Header from "../utils/Header";
import Box from '@mui/material/Box';
import moment from 'moment';
import { useState, useEffect } from 'react';
import MaterialUICalandar from "../utils/MaterialUICalandar";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Add from "../utils/Add";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';



const HomePage = ({ session, supabase, handleLogout }) => {
  const [feelingdays, setfeelingDays] = useState("");
  const [fightdays, setfightDays] = useState("");
  const [date, setDate] = useState();
  const [feelings, setfeelings] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [fightsWithFeelings, setFightsWithFeelings] = useState([]);
  const [unlinkedFeelings, setUnlinkedFeelings] = useState([]);
  const [selectedFight, setSelectedFight] = useState("")

  useEffect(() => {
    setDate(moment());
    get_all_feelings(moment(), session.user.id);
    get_feelings_for_one_day(moment(), session.user.id)
    get_fights_with_feelings_for_one_day(moment(), session.user.id)
  }, [session])

  useEffect(() => {
    if (date && session?.user?.id) {
      get_fights_with_feelings_for_one_day(date, session.user.id);
    }
  }, [date, session]);

  useEffect(()=>{
    if(!modalShow){
      setSelectedFight("")
    }
  },[modalShow])


// what is the workflow here

  //BF get fight days to mark calendar with angry emoji, I do not need more information such as fight text here.
  const get_all_feelings = async (month, user_id) => {
    
     console.log(moment(month).startOf("month").format("YYYY-MM-DD"))
    const startOfMonth = moment(month).startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment(month).endOf("month").format("YYYY-MM-DD");
    const { data } = await supabase.from("fights")
      .select(` start_date `)
      .gte("start_date", startOfMonth)
      .lte("end_date", endOfMonth)
      .eq("user_id", user_id);
    setfeelingDays([...data]);
  };

  // const addEvent = async (fight) => {
  //   await supabase
  //     .from("fights")
  //     .insert({ ...fight });
  //   // BF 17-JULY-2025 get all feelings after adding one
  //   get_all_feelings(fight.start_date, session.user.id);
  //   get_feelings_for_one_day(fight.start_date, session.user.id);
  // };

  // BF Get all feelings for one day, when the date changes or the calendar changes
  const get_feelings_for_one_day = async (selected_date, user_id) => {
    let temp_date = moment(selected_date).format("YYYY-MM-DD");
    const { data } = await supabase.from("fights")
      .select()
      .eq("start_date", temp_date)
      .eq("user_id", user_id);
    setfeelings(data);
  }

  const get_all_fights = async () => {
    const user_id = session.user.id;
    const { data, error } = await supabase
      .from("fight")
      .select("*")
      .eq("user_id", user_id);

    if (error) {
      console.error("Error fetching fights:", error.message);
    }
      setfightDays([...data]);

      return data;
    
  };

  const get_fights_with_feelings_for_one_day = async (selected_date, user_id) => {
    let temp_date = moment(selected_date).format("YYYY-MM-DD");

    const { data } = await supabase
      .from("fight")
      .select(`
      fight_id,
      topic,
      category,
      resolved,
      start_date,
      fights (
        id,
        feeling,
        start_date,
        fight_id
      )
    `)
      .eq("user_id", user_id)


    console.log("Fetched fights data:", data);

    const fightsWithFeelings = (data ?? [])
      .map(fight => {
        const filteredFeelings = fight.fights?.filter(f => {
          const feelingDate = f.start_date?.split('T')[0];
          console.log(`Comparing feelingDate: ${feelingDate} to temp_date: ${temp_date}`);
          return feelingDate === temp_date;
        });

        return filteredFeelings.length > 0 ? { ...fight, fights: filteredFeelings } : null;
      })
      .filter(Boolean);

    console.log("Filtered fights:", fightsWithFeelings);

    const { data: unlinkedFeelings } = await supabase
      .from("fights")
      .select()
      .eq("user_id", user_id)
      .eq("start_date", temp_date)
      .is("fight_id", null);  // feelings without fight_id

    console.log("Feelings no fights:", unlinkedFeelings);
    setFightsWithFeelings(fightsWithFeelings);
    setUnlinkedFeelings(unlinkedFeelings || []);

  };

  const handleAddSubmit = async ({ feelingData, newFightData }) => {
    try {
      let fightId = feelingData.fight_id;
      // Insert new fight if provided
      if (newFightData) {
        const { data: fightInsert, error: fightError } = await supabase
          .from("fight")
          .insert([newFightData])
          .select("fight_id")
          .single();

        if (fightError) throw fightError;
        fightId = fightInsert.fight_id;
        console.log(fightInsert)
      }


      // Insert feeling linked to fightId (new or existing)
      const feelingToInsert = {
        ...feelingData,
        fight_id: fightId,
      };

      const { error: feelingError } = await supabase
        .from("fights")
        .insert([feelingToInsert]);

      if (feelingError) throw feelingError;
      // Refresh data after insertion
      get_all_feelings(feelingToInsert.start_date, session.user.id);
      get_feelings_for_one_day(feelingToInsert.start_date, session.user.id);
      get_fights_with_feelings_for_one_day(feelingToInsert.start_date, session.user.id);
      
      setModalShow(false);
      return true;
    } catch (error) {
      console.error("Error adding fight or feeling:", error);
    }
  };

  const handleUpdate = async(fight) =>{
            let temp_fight = {...fight}
            let feelings = fight.fights;
            if(feelings){
              feelings[0].feeling = fight.feeling
            }
            delete temp_fight.fights;
            delete temp_fight.feeling;
            const { data, error } = await supabase
              .from('fight')
              .update({...temp_fight})
              .eq('fight_id', fight.fight_id); // Filter by primary key or other unique identifier

            if (error) {
              console.error('Error updating record:', error.message);
            } else {
              console.log('Record updated successfully:', data);
            }
          
            if(feelings){
                 feelings = feelings[0];
                 const { data2, error2 } = await supabase
                   .from('fights')
                   .update({...feelings})
                   .eq('id', feelings.id); // Filter by primary key or other unique identifier
     
                 if (error2) {
                   console.error('Error updating record:', error.message);
                 } else {
                   console.log('Record updated successfully:', data);
                 }
            }
            get_all_feelings(fight.start_date, session.user.id);
            get_feelings_for_one_day(fight.start_date, session.user.id);
            get_fights_with_feelings_for_one_day(fight.start_date, session.user.id);
  }

  return (
    <div>
      <Header session={session} handleLogout={handleLogout} />
      <Box component="main" sx={{ p: 3 }}>
        <Paper elevation={3}>
          <MaterialUICalandar
            date={date}
            feeling={feelingdays}
            get_feelings_for_one_day={get_feelings_for_one_day}
            get_all_feelings={get_all_feelings}
            get_fights_with_feelings_for_one_day={get_fights_with_feelings_for_one_day}
            setFightsWithFeelings={setFightsWithFeelings}
            setDate={setDate}
            setfeelings={setfeelings}
            session={session}
          />
        </Paper>

      </Box>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained" style={{ backgroundColor: "#dc3545" }}
          onClick={() => {
            setModalShow(true);
          }}
        >
          (ง•̀_•́)ง Add
        </Button>
      </div>
      <div>
        <Add
          show={modalShow}
          onHide={() => {
            setModalShow(false);
            setSelectedFight("")
          }}
          //addEvent={addEvent}
          onSubmit={handleAddSubmit}
          date={date}
          session={session}
          get_all_fights={get_all_fights}
          selectedFight={selectedFight?.fight}
          handleUpdate={handleUpdate}
        />


    {fightsWithFeelings.map((fight) => (
      <div
        key={fight.fight_id}
        style={{
          margin: "10px",
          borderBottom: "2px solid #a6a6a6",
          background: "#fffefe",
          boxShadow: "0 8px 8px -4px #ff7885",
          padding: "10px",
        }}
      >
         <Button
                variant="contained" style={{ backgroundColor: "#dc3545" }}
                onClick={() => {
                  setModalShow(true);
                  setSelectedFight({fight})
                }}
              >
                Edit
              </Button>
        <Accordion>
          <AccordionSummary>

            
            <div>
              <strong>{fight.topic || `Fight on ${fight.start_date}`}</strong>
              <br />
              {fight.fights?.length > 0 ? (
                <>
                  Feelings recorded: {fight.fights.length} <br />
                  Reason for Fight: {fight.category}
                </>
              ) : (
                "No feelings recorded"
              )}
              
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <ul>
              {console.log(fight)}
              {fight.fights.map((f) => (
                <li key={f.id}>
                  Feeling: {f.feeling}, Date: {f.start_date}
                </li>
              ))}
            </ul>
          </AccordionDetails>
        </Accordion>
      </div>
    ))
  }
   

  {unlinkedFeelings.length > 0 && (
    <div
      style={{
        margin: "10px",
        borderBottom: "2px solid #a6a6a6",
        background: "#fffefe",
        boxShadow: "0 8px 8px -4px #aaa",
        padding: "10px",
      }}
    >
      <Accordion>
        <AccordionSummary>
          <div>
            <strong>Feelings without a fight</strong>
            <br />
            <>Feelings recorded: {unlinkedFeelings.length}
            
            
            </>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            {unlinkedFeelings.map((f) => (
              <li key={f.id}>
                Feeling: {f.feeling}, Date: {f.start_date}
              </li>
            ))}
          </ul>
        </AccordionDetails>
      </Accordion>
    </div>
  )}



      </div>
    </div>
  )
}

export default HomePage
